"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authSessionResume = exports.authSessionPause = exports.authSessionEnd = exports.authSessionStart = exports.accessTokenUnavailable = exports.accessTokenAvailable = exports.fetchAuthUserFailure = exports.fetchAuthUserSuccess = exports.fetchAuthUserRequest = exports.stopTokenRefresh = exports.startTokenRefresh = exports.refreshTokens = exports.setTokens = exports.logout = exports.stopLogin = exports.login = void 0;

var _actionType = require("./actionType");

var login = function login(credentials) {
  return {
    type: _actionType.AUTH_LOGIN,
    credentials: credentials
  };
};

exports.login = login;

var stopLogin = function stopLogin(error, user) {
  if (error) {
    return {
      type: _actionType.AUTH_LOGIN_FAILURE,
      error: error
    };
  }

  return {
    type: _actionType.AUTH_LOGIN_SUCCESS,
    user: user
  };
};

exports.stopLogin = stopLogin;

var logout = function logout() {
  return {
    type: _actionType.AUTH_LOGOUT
  };
};

exports.logout = logout;

var setTokens = function setTokens(tokens) {
  return {
    type: _actionType.SET_AUTH_TOKENS,
    tokens: tokens
  };
};

exports.setTokens = setTokens;

var refreshTokens = function refreshTokens(tokens) {
  return {
    type: _actionType.PROCESS_TOKEN_REFRESH,
    tokens: tokens
  };
};

exports.refreshTokens = refreshTokens;

var startTokenRefresh = function startTokenRefresh(refreshToken) {
  return {
    type: _actionType.AUTH_REFRESH_TOKEN,
    refreshToken: refreshToken
  };
};

exports.startTokenRefresh = startTokenRefresh;

var stopTokenRefresh = function stopTokenRefresh(error) {
  var tokens = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (error) {
    return {
      type: _actionType.AUTH_REFRESH_TOKEN_FAILURE,
      error: error
    };
  }

  return {
    type: _actionType.AUTH_REFRESH_TOKEN_SUCCESS,
    tokens: tokens
  };
};

exports.stopTokenRefresh = stopTokenRefresh;

var fetchAuthUserRequest = function fetchAuthUserRequest() {
  return {
    type: _actionType.FETCH_AUTH_USER_REQUEST
  };
};

exports.fetchAuthUserRequest = fetchAuthUserRequest;

var fetchAuthUserSuccess = function fetchAuthUserSuccess(user) {
  return {
    type: _actionType.FETCH_AUTH_USER_SUCCESS,
    user: user
  };
};

exports.fetchAuthUserSuccess = fetchAuthUserSuccess;

var fetchAuthUserFailure = function fetchAuthUserFailure(error) {
  return {
    type: _actionType.FETCH_AUTH_USER_FAILURE,
    error: error
  };
};

exports.fetchAuthUserFailure = fetchAuthUserFailure;

var accessTokenAvailable = function accessTokenAvailable(accessToken) {
  return {
    type: _actionType.ACCESS_TOKEN_AVAILABLE,
    payload: accessToken
  };
};

exports.accessTokenAvailable = accessTokenAvailable;

var accessTokenUnavailable = function accessTokenUnavailable() {
  return {
    type: _actionType.ACCESS_TOKEN_UNAVAILABLE
  };
};

exports.accessTokenUnavailable = accessTokenUnavailable;

var authSessionStart = function authSessionStart() {
  return {
    type: _actionType.AUTH_SESSION_START
  };
};

exports.authSessionStart = authSessionStart;

var authSessionEnd = function authSessionEnd() {
  return {
    type: _actionType.AUTH_SESSION_END
  };
};

exports.authSessionEnd = authSessionEnd;

var authSessionPause = function authSessionPause() {
  return {
    type: _actionType.AUTH_SESSION_PAUSE
  };
};

exports.authSessionPause = authSessionPause;

var authSessionResume = function authSessionResume() {
  return {
    type: _actionType.AUTH_SESSION_RESUME
  };
};

exports.authSessionResume = authSessionResume;